// validators.ts
import { object, string, number, boolean, optional, oneOf, date } from "justus";
import { uuid } from "justus/extra/uuid";
var amountCents = number({
  multipleOf: 1,
  minimum: 0
});
var method = oneOf("creditcard", "paypal", "applepay", "klarna", "giropay", "invoice", "sepa_debit");
var paymentStatusValidator = oneOf("open", "cancelled", "pending", "expired", "failed", "approved", "authorized", "paid", "refunded", "refund_pending");
var refundStatusValidator = oneOf("pending", "succeeded", "failed", "cancelled");
var paymentValidator = object({
  uuid,
  created: date({ format: "iso" }),
  modified: date({ format: "iso" }),
  order_uuid: uuid,
  user_uuid: uuid,
  method: optional(method),
  amount_cents: amountCents,
  status: paymentStatusValidator,
  authorized_at: optional(date({ format: "iso" })),
  paid_at: optional(date({ format: "iso" })),
  expires_at: optional(date({ format: "iso" })),
  expired_at: optional(date({ format: "iso" })),
  refunded_at: optional(date({ format: "iso" })),
  amount_cents_captured: optional(amountCents),
  amount_cents_refunded: optional(amountCents),
  /* Payment details */
  details: optional(string),
  checkout_url: optional(string),
  client_secret: optional(string),
  automatic: boolean,
  mandate_uuid: optional(uuid)
});
var oneOffPaymentOptionValidator = object({
  order_uuid: uuid,
  redirect_url: string,
  cancel_url: optional(string),
  // No giropay anymore
  method: optional(oneOf("creditcard", "paypal", "applepay", "klarna", "invoice", "sepa_debit")),
  // Optional for orders with 100% discount!
  confirmation_token: optional(string),
  preferences: optional(Object({
    /* @deprecated it has no effect on the behavior */
    automatic: optional(boolean),
    /* @deprecated user `save_method` instead to save the payment method */
    save_details: optional(boolean),
    save_method: optional(boolean)
  }))
});
var oneOffMandatePaymentOptionValidator = object({
  order_uuid: uuid,
  mandate_uuid: uuid,
  redirect_url: string,
  cancel_url: optional(string)
});
var oneOffPaymentValidator = oneOf(oneOffPaymentOptionValidator, oneOffMandatePaymentOptionValidator);
var refundResponseValidator = object({
  external_id: string,
  status: refundStatusValidator,
  amount: amountCents
});
var baseMandateValidator = {
  uuid,
  created: date({ format: "iso" }),
  user_uuid: uuid,
  default: boolean
};
var creditcardMandateValidator = object({
  ...baseMandateValidator,
  method: "creditcard",
  description: {
    brand: string,
    last4: string,
    exp_month: number,
    exp_year: number
  }
});
var paypalMandateValidator = object({
  ...baseMandateValidator,
  method: "paypal",
  description: {
    email: string
  }
});
var sepaMandateValidator = object({
  ...baseMandateValidator,
  method: "sepa_debit",
  description: {
    bank_code: optional(string),
    branch_code: optional(string),
    country: optional(string),
    last4: optional(string)
  }
});
var mandateValidator = oneOf(creditcardMandateValidator, paypalMandateValidator, sepaMandateValidator);
export {
  amountCents,
  creditcardMandateValidator,
  mandateValidator,
  method,
  oneOffMandatePaymentOptionValidator,
  oneOffPaymentOptionValidator,
  oneOffPaymentValidator,
  paymentStatusValidator,
  paymentValidator,
  paypalMandateValidator,
  refundResponseValidator,
  refundStatusValidator,
  sepaMandateValidator
};
//# sourceMappingURL=validators.mjs.map
